"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  drawer: {
    width: '100%',
    maxWidth: '92px'
  },
  drawerPaper: {
    'overflow': 'scroll',
    'backgroundColor': _episourceColor["default"].epiAnalystBackground,
    '&::-webkit-scrollbar': {
      width: 0
    },
    'top': 'initial !important',
    'position': 'fixed'
  },
  list: {
    'padding': 0,
    '&& a': {
      'padding': '16px 2px',
      'width': '100%',
      'display': 'flex',
      'alignItems': 'center',
      'flexDirection': 'column',
      'justifyContent': 'center',
      'color': _episourceColor["default"].iconDefault,
      'fontFamily': 'Lato',
      'textDecoration': 'none',
      'gap': '3px',
      '&.Mui-selected': {
        'background': _episourceColor["default"].textContrast,
        'color': _episourceColor["default"].primaryMain,
        'position': 'relative',
        '&::before': {
          content: '""',
          width: '4px',
          position: 'absolute',
          top: '0',
          left: '0',
          height: '100%',
          background: _episourceColor["default"].epiAnalystPrimaryMarkerting
        },
        '&:hover': {
          textDecoration: 'none'
        },
        '& svg': {
          'color': _episourceColor["default"].primaryMain,
          '& path': {
            fill: _episourceColor["default"].primaryMain
          }
        }
      },
      '&:not(.active):hover': {
        backgroundColor: '#fff',
        color: _episourceColor["default"].iconHover,
        textDecoration: 'none'
      }
    },
    '&& .MuiListItemText-root': {
      margin: 0
    },
    '&& .MuiTypography-root': {
      fontSize: '14px',
      fontWeight: '400',
      letterSpacing: '0.1px',
      margin: '0px 10px',
      textTransform: 'capitalize',
      textAlign: 'center'
    },
    '&& .MuiListItemIcon-root': {
      minWidth: 'unset'
    },
    '&& .MuiSvgIcon-root': {
      'color': _episourceColor["default"].iconDefault,
      'fontSize': '24px',
      '& path': {
        fill: _episourceColor["default"].iconDefault
      }
    }
  }
}));
const SideNavVersion2 = _ref => {
  let {
    topOffset,
    appBarRef,
    children
  } = _ref;
  const [open] = (0, _react.useState)(false);
  const [offset, setOffset] = (0, _react.useState)(topOffset || 'auto');
  if (!topOffset) {
    (0, _react.useEffect)(() => {
      const scrollCallback = () => {
        setTimeout(() => {
          if (appBarRef && appBarRef.current) {
            const rect = appBarRef.current.getBoundingClientRect();
            const newOffset = rect ? rect.height + rect.top : 0;
            setOffset(newOffset >= 56 ? newOffset : 'auto');
          }
        });
      };
      window.addEventListener('scroll', scrollCallback);
      if (appBarRef && appBarRef.current) {
        appBarRef.current.addEventListener('click', scrollCallback);
      }
      return () => {
        window.removeEventListener('scroll', scrollCallback);
        if (appBarRef && appBarRef.current) {
          appBarRef.current.removeEventListener('click', scrollCallback);
        }
      };
    }, []);
  }
  const classes = useStyles({
    offset
  });
  return /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    variant: "permanent",
    className: (0, _clsx["default"])(classes.drawer),
    classes: {
      paper: (0, _clsx["default"])(classes.drawerPaper)
    }
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: (0, _clsx["default"])(classes.list, {})
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children)));
};
var _default = SideNavVersion2;
exports["default"] = _default;